import { Typography } from '@sweep-io/sweep-design';
import { dataTableVariants } from '../../../common/table/dataTableVariants';
import { DataTableVariant } from '../../../common/table/TableTypes';
import { ConfigurationType } from '../../dependencies/types';
import { ReactNode } from 'react';
import { RuleType } from '../../../parser/ParserTypes';
import { SearchResponse } from '../../universal-search/types';
import { isItemActive } from '../../helpers';
import { UserConfigurationsByUserType, UserInputTypes } from '@server/user-inputs';
import { ConfigurationItem } from '../../dependencies/DependenciesTypes';

export const TableTypography = ({
  children,
  variant = DataTableVariant.small,
  textColor,
}: {
  children: string | ReactNode;
  variant?: DataTableVariant;
  textColor?: string;
}) => {
  return (
    <>
      {typeof children === 'string' ? (
        <Typography
          variant={dataTableVariants[variant].fontVariant}
          color={textColor ?? dataTableVariants[variant].fontColor}
          whiteSpace="break-spaces"
          wordBreak="break-all"
        >
          {children}
        </Typography>
      ) : (
        children
      )}
    </>
  );
};

export type ConfigurationItemMap = {
  [key in ConfigurationType | RuleType]: ConfigurationItem[];
};

export interface TagConfigurations extends UserConfigurationsByUserType {
  [UserInputTypes.Tags]: string[];
}

export const prepareConfigItemMapStructure = (items?: ConfigurationItemMap | SearchResponse) => {
  if (!items) {
    return;
  }

  return Object.keys(items).reduce((acc: any, key) => {
    const itemsOfKey = items[key as keyof (ConfigurationItemMap | SearchResponse)];

    acc[key] = itemsOfKey.map((item: any) => ({
      id: item.id ?? '',
      lastModified: item.annotations?.changedAt,
      label: item.label,
      type: item.type,
      flowType: item.flowType,
      objectName: item.objectName ?? '',
      objectLabel: item.objectLabel,
      name: item.name,
      isActive: isItemActive(item),
    }));
    return acc as ConfigurationItemMap;
  }, {});
};
